/**
 * Canonical NAFED collection registry.
 *
 * Every portal must use these names so PACS, PMC, State Branch, Registrar,
 * Bank and Head Office continue to read the same business records. Do not
 * create shadow collections for an existing workflow.
 */
export const NAFED_COLLECTIONS = Object.freeze({
  users: "nafed_users",
  godownProjects: "godown_projects",
  pacsPmcAllocations: "pacs_pmc_allocations",
  workflowProjects: "wf_projects",
  workflowTasks: "wf_project_tasks",
  workVendors: "work_vendors",
  tenders: "tenders",
  raBills: "ra_bills",
  engineerRaBills: "ra_bills_engineer",
  finalRaBills: "ra_bills_final",
  contractorDocs: "nafed_contractor_documents",
  notifications: "nafed_notifications",
  activity: "nafed_activity",
  mailQueue: "mail",
  hiringAssurances: "nafed_hiring_assurances",
});

/**
 * Read-only migration reference. New writes must never use these aliases.
 */
export const LEGACY_NAFED_COLLECTIONS = Object.freeze({
  godownProjects: "nafed_godown_projects",
  workflowProjects: "nafed_wf_projects",
  tenders: "nafed_tenders",
  raBills: "nafed_ra_bills",
  engineerRaBills: "nafed_ra_bills_engineer",
  finalRaBills: "nafed_ra_bills_final",
  mailQueue: "nafed_mail_notifications",
});

export const collectionName = (key) => {
  const name = NAFED_COLLECTIONS[key];
  if (!name) throw new Error(`Unknown NAFED collection key: ${key}`);
  return name;
};
